<template>
  <v-container fluid>
    <v-row align="center" justify="space-around">
      <v-col cols="12" md="10">
        <v-row class="mx-4 my-4" align="center" justify="space-around">
          <v-col align="center" class="my-4">
            <h3 class="text-h6 mb-4">
              {{ $t("login.warning") }}
            </h3>
            <v-btn large @click="logIn" depressed color="primary">
              {{ $t("login.connect") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider />
        <v-row class="mx-4 my-4" align="center" justify="space-around">
          <v-col align="center">
            <h3 class="text-h8 text-md-h6 mb-2">{{ $t("login.learnMore") }}</h3>
            <v-btn small depressed color="secondary" link to="/about">
              {{ $t("login.about") }}
            </v-btn>
          </v-col>
          <v-col align="center">
            <h3 class="text-h8 text-md-h6 mb-2">
              {{ $t("login.ourUsefullLinks") }}
            </h3>
            <v-btn small depressed color="secondary" link to="/links">
              {{ $t("login.usefullLinks") }}
            </v-btn>
          </v-col>
          <v-col align="center">
            <h3 class="text-h8 text-md-h6 mb-2">{{ $t("login.question") }}</h3>
            <v-btn small depressed color="secondary" link to="/contact">
              {{ $t("login.contact") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    async logIn() {
      try {
        //authentification
        await this.$authService.signIn();
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
